/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.26.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserCustomWorkorderFilterFromJSON, UserCustomWorkorderFilterToJSON, } from './';
export function SaveUserCustomFilterCommandFromJSON(json) {
    return SaveUserCustomFilterCommandFromJSONTyped(json, false);
}
export function SaveUserCustomFilterCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'customFilter': !exists(json, 'customFilter') ? undefined : UserCustomWorkorderFilterFromJSON(json['customFilter']),
    };
}
export function SaveUserCustomFilterCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'customFilter': UserCustomWorkorderFilterToJSON(value.customFilter),
    };
}
